import { Navigate } from "react-router-dom";
import ConsoleHelper from "utils/ConsoleHelper";

function RequireSubscription({
  children,
  isAuth,
  isVerified,
  hasActiveSubscription,
}) {
  if (!isAuth) {
    ConsoleHelper(
      "RequireSubscription",
      "User is not authenticated, redirecting to login"
    );
    return <Navigate to="/auth/login" replace />;
  }
  if (!isVerified) {
    ConsoleHelper(
      "RequireSubscription",
      "User is not verified, redirecting to verify"
    );
    return <Navigate to="/verify" replace />;
  }
  if (!hasActiveSubscription) {
    ConsoleHelper(
      "RequireSubscription",
      "User does not have an active subscription, redirecting to subscription page"
    );
    return <Navigate to="/subscriptionv2" replace />;
  }
  return children;
}

export default RequireSubscription;
